const router = {
  path: '/bind',
  name: 'Bind',
  meta: { title: '绑定', type: 'user' },
  component: () => import('@/components/Layout'),
  children: [
    {
      path: '/bind/unbound/:iccid/:rnrId/:vin',
      name: 'Unbound',
      component: () => import('@/views/bind/unbound'),
      meta: { title: '解绑', type: 'user' }
    },
    {
      path: '/bind/rebind/:iccid/:rnrId/:vin',
      name: 'Rebind',
      component: () => import('@/views/bind/rebind'),
      meta: { title: '重新绑定', type: 'user' }
    }
  ]
}
export default router



// WEBPACK FOOTER //
// ./src/router/bind.js